module.exports = __webpack_public_path__ + "static/media/cert_154.ad63988a.jpg";